import { useEffect, useState } from "react";
import { openNotificationWithIcon } from "../../utils/helper";
import { getRewards } from "../../api/rewards/rewards";

const useRewards = () => {
  const [rewards, setRewards] = useState<any>([]);
  const [loadingRewards, setLoadingRewards] = useState(false);

  const fetchRewards = async () => {
    try {
      setLoadingRewards(true);
      const res = await getRewards();
      const { data } = res.data;
      setRewards(data);
      setLoadingRewards(false);
    } catch (error: any) {
      setLoadingRewards(false);
      if (error?.response) {
        openNotificationWithIcon(
          "error",
          "Get Rewards",
          `${error?.response?.data?.message || "Something went wrong"}`
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Get Rewards",
          "Something went wrong"
        );
      }
    }
  };

  useEffect(() => {
    fetchRewards();

    // eslint-disable-next-line
  }, []);

  return { rewards, loadingRewards };
};

export default useRewards;
